import React, { useEffect, useState } from 'react';
import axios from '../../services/MyAxios';
import { useParams } from 'react-router-dom';
import PostbackDetails from './PostbackDetails';

function PostbackShow() {
    let { id } = useParams();
    const [postback, setPostback] = useState({});
    const url = '/crea/api/postback/' + id;

    useEffect(() => {
        getPostback();
    }, []);

    function getPostback() {
        axios.get(url).then((response) => {
            setPostback(response.data);
        });
    }

    return (
        <div>
            <PostbackDetails postback={postback} />
        </div>
    );
}

export default PostbackShow;
